import React, { useState } from "react";
import "./WhyChooseUsSection.css";
import { useAuth } from "../../Store/AuthContext";
import { WhyChooseFetchData } from "../../APIS/FetchAPIs";

function ReadMore({ text, maxLines = 3 }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="readmore-container">
      <p
        className={`readmore-text ${expanded ? "expanded" : ""}`}
        style={{
          WebkitLineClamp: expanded ? "unset" : maxLines,
        }}
      >
        {text}
      </p>
      <button className="readmore-btn" onClick={() => setExpanded(!expanded)}>
        {expanded ? "Show Less" : "Show More"}
      </button>
    </div>
  );
}

export default function WhyChooseUsSection() {
  const { RendomTokenfetch } = useAuth();
  const [WhyChooseData, loading] = WhyChooseFetchData(RendomTokenfetch);

  return (
    <section className="services section-padding">
      <div className="container">
        <div className="row section-title">
          <div className="col col-md-8 col-md-offset-2">
            <h2>We Are Best In Solving SME's Problems</h2>
            <p>
              Our highly customized teams bring each client a combination of
              deep industry knowledge and expert perspectives from other
              industries on the challenge at stake.
            </p>
          </div>
        </div>

        <div className="row content services-grids">
          {loading ? (
            <p className="text-center">Loading Who We Are...</p>
          ) : WhyChooseData.length > 0 ? (
            WhyChooseData.map((valData, index) => (
              <div className="col col-lg-4 col-sm-6" key={index}>
                <div className="grid">
                  <div
                    className="icon"
                    dangerouslySetInnerHTML={{
                      __html: valData.icon,
                    }}
                  ></div>
                  <h3>{valData.title}</h3>
                  <ReadMore text={valData.tagline} />
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">No available right now.</p>
          )}

          {/* <div className="col col-lg-4 col-sm-6">
            <div className="grid">
              <div className="icon">
                <i className="fi flaticon-money-1"></i>
              </div>
              <h3>Precision</h3>
              <ReadMore text="We are committed to absolute precision in identifying areas of improvement or issues, and in delivering the best, most simple, and perfectly suited solutions to address critical challenges." />
            </div>
          </div>

          <div className="col col-lg-4 col-sm-6">
            <div className="grid">
              <div className="icon">
                <i className="fi flaticon-money"></i>
              </div>
              <h3>Integrity</h3>
              <ReadMore text="We live by the highest standards of integrity and always conduct ourselves in alignment with those values." />
            </div>
          </div>

          <div className="col col-lg-4 col-sm-6">
            <div className="grid">
              <div className="icon">
                <i className="fi flaticon-graphic"></i>
              </div>
              <h3>Growth</h3>
              <ReadMore text="We champion well-paced, strong and continuous growth that strengthens teamwork, enhances client experience, and elevates our management approach. We approach failure as a stepping stone, using it to learn, innovate, and evolve. By investing in upskilling, reskilling, and the courage to unlearn and relearn, we build a resilient team capable of reimagining how we work and grow towards solving the new challenges of tomorrow." />
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
